function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var lurkerSend = function lurkerSend(event_type, object_name, object_detail) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // eslint-disable-line
  var payload = _objectSpread({
    event_type: event_type,
    object_name: object_name,
    object_detail: object_detail
  }, data);
  if (!window.Lurker) {
    window.beforeLurkerLoadEvents = window.beforeLurkerLoadEvents || [];
    window.beforeLurkerLoadEvents.push(payload);
    return;
  }
  window.Lurker.send(payload)["catch"](console.error); // eslint-disable-line no-console
};
export var clickOpenSecurityModal = function clickOpenSecurityModal(extra) {
  return lurkerSend('click', 'security_central_modal', 'open_modal', _objectSpread({}, extra));
};
export var clickCloseSecurityModal = function clickCloseSecurityModal(extra) {
  return lurkerSend('click', 'security_central_modal', 'close_modal', _objectSpread({}, extra));
};
export var clickOpenLinkSecurityModal = function clickOpenLinkSecurityModal(extra) {
  return lurkerSend('click', 'security_central_modal', 'open_link_modal', _objectSpread({}, extra));
};
export var clickAlertBoxSecurityModal = function clickAlertBoxSecurityModal(extra) {
  return lurkerSend('click', 'security_central_modal', 'click_alert_box', _objectSpread({}, extra));
};
export var clickChangeTab = function clickChangeTab(tabId, idPage) {
  return lurkerSend('click', 'security_central_modal', 'change_tab', {
    tabId: tabId,
    idPage: idPage
  });
};
export var viewSecurityCentralBanner = function viewSecurityCentralBanner(idPage) {
  return lurkerSend('view', 'security_central_modal', 'banner', {
    idPage: idPage
  });
};
export var saveYoutubePlayerState = function saveYoutubePlayerState(_ref) {
  var titleVideo = _ref.titleVideo,
    idYoutube = _ref.idYoutube,
    state = _ref.state;
  return lurkerSend('view', 'youtube_player_state', 'change_state', {
    titleVideo: titleVideo,
    idYoutube: idYoutube,
    state: state
  });
};
export var sendClickRate = function sendClickRate(objDetaildurker, lurkerObjName, extras) {
  return lurkerSend('click', lurkerObjName || 'chat', objDetaildurker, _objectSpread({}, extras));
};
export var loadStorageError = function loadStorageError(value, exception, objDetaildurker) {
  return lurkerSend('error', objDetaildurker, 'storage', {
    value: value,
    exception: "".concat(exception)
  });
};